<section class="w-full">
    <section class="flex flex-col justify-center items-center gap-3">
        <section class="w-48"><img src="assets/images/practical-it-logo.png" /></section>
        <form class="w-1/2" [formGroup]="resetPasswordForm" (submit)="resetPassword()">
            <section class="flex flex-col border border-blue-800 gap-3">
                <section>
                    <input class="w-full" placeholder="password" formControlName="password">
                </section>
                <button mat-raised-button color="primary">Reset Password</button>
                <section>
                    <app-banner-message *ngIf="submitted && !pending" [success]="success" [majorMessage]="message"></app-banner-message>
                </section>                      
            </section>
        </form>
        <section class="flex gap-5">
            <!-- <a routerLink="/register">Register</a> -->
            <a routerLink="/">Login</a>
        </section>
    </section>
</section>
